export default __webpack_public_path__ + "media/WeightGraphMed.8537026e36d0dd46b63ec9442a38576c.webp";